import _ from 'underscore';
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import {
  expressionTokenTypes,
  providesProps,
  sharedProps,
  sharedDefaults,
  providesDefaults,
} from '@bingads-webui-react/hoc-with-expression-editor-controls';
import { InputAutocomplete } from './input-autocomplete';
import { SelectedMetric } from './selected-metric';
import { Operator } from './operator';

const { TEXT, COLUMN, OPERATOR } = expressionTokenTypes;
const propsConsumedFromHoc = [
  'currentFocus',
  'expressionTokens',
  'onDropdownValueSelectedFactory',
  'onFocusFactory',
  'onInputChangeFactory',
  'onInputClickFactory',
  'onInputKeyUpFactory',
  'onMetricKeyUpFactory',
  'onMetricRemoveButtonClickFactory',
  'setRefFactory',
];

export class Expression extends React.PureComponent {
  static propTypes = PropTypes.shape(_.defaults({
    className: PropTypes.string,
    autoCompleteDropDownClassName: PropTypes.string,
    i18n: PropTypes.shape({ getString: PropTypes.func.isRequired }).isRequired,
    id: PropTypes.string.isRequired,
    onClick: PropTypes.func,
    tokenClassName: PropTypes.string,
    zIndexStart: PropTypes.number,
  }, sharedProps, _.pick(providesProps, propsConsumedFromHoc))).isRequired;

  static defaultProps = _.defaults({
    className: 'expression-container',
    tokenClassName: 'custom-column-expression-token',
    onClick: _.noop,
    zIndexStart: 1000,
  }, sharedDefaults, _.pick(providesDefaults, propsConsumedFromHoc));

  render() {
    const {
      className,
      currentFocus,
      mostRecentMetricFocus,
      expressionTokens,
      autoCompleteDropDownClassName,
      i18n,
      id,
      metricCategories,
      onClick,
      onDropdownValueSelectedFactory,
      onFocusFactory,
      onInputChangeFactory,
      onInputClickFactory,
      onInputKeyUpFactory,
      onMetricKeyUpFactory,
      onMetricRemoveButtonClickFactory,
      setRefFactory,
      tokenClassName,
      zIndexStart,
      containerRef,
    } = this.props;

    const expression = _.map(expressionTokens, (token, index) => {
      const exprToken = jsx => (
        <div
          key={`${index}-${token.value}`}
          className={tokenClassName}
          ref={token.type === TEXT ? setRefFactory(index) : null}
        >
          {jsx}
        </div>
      );
      const isFocused = index === currentFocus;
      const isMetricSelected = (index === mostRecentMetricFocus) &&
        (expressionTokens[index].type === COLUMN);

      switch (token.type) {
        case TEXT:
          return exprToken((
            <InputAutocomplete
              i18n={i18n}
              value={token.value}
              isFocused={isFocused}
              suggestions={metricCategories}
              showSuggestions={token.showSuggestions && isFocused}
              onFocus={onFocusFactory(index)}
              onClick={onInputClickFactory(index)}
              onChange={onInputChangeFactory(index)}
              onKeyUp={onInputKeyUpFactory(index)}
              onDropdownValueSelected={onDropdownValueSelectedFactory(index)}
              autoCompleteDropDownClassName={autoCompleteDropDownClassName}
              zIndexStart={zIndexStart + 5}
            />
          ));
        case COLUMN:
          return exprToken((
            <SelectedMetric
              i18n={i18n}
              expressionToken={token}
              isMetricSelected={isMetricSelected}
              isFocused={isFocused}
              onRemoveButtonClick={onMetricRemoveButtonClickFactory(index)}
              onSelect={onFocusFactory(index)}
              onKeyUp={onMetricKeyUpFactory(index)}
            />
          ));
        case OPERATOR:
          return exprToken((
            <Operator value={token.title} />
          ));
        default:
          return null;
      }
    });

    return (
      <div
        id={id}
        className={classNames(className, 'input')}
        onClick={onClick}
        role="presentation"
        ref={containerRef}
      >
        {expression}
      </div>
    );
  }
}
